import { Component, OnInit } from '@angular/core';
import { ObservationService } from '../../../observations/services/observation.service';
import { ToastService, RouteService } from '@kaiser-software/chassis-core';
import { Router } from '@angular/router';

@Component({
    selector: 'eyewatch-most-returning-observation-categories-widget',
    templateUrl: './most-returning-observation-categories.component.html',
    styleUrls: [ './most-returning-observation-categories.component.scss' ]
})
export class MostReturningObservationCategoriesComponent implements OnInit {

    public chart: {
        data?: Array<{
            data: Array<number>,
            label: string,
        }>,
        labels?: Array<string>,
        options?: Object,
        colors?: any,
    };

    constructor(public observationService: ObservationService, private toastService: ToastService, private routeService: RouteService, private router: Router) {
    }

    ngOnInit() {
        const url = this.observationService.getEndpointUrl() + '/most_returning_observation_categories_widget';

        const request = this.observationService.custom('get', url);

        request.subscribe((result: Array<any>) => {
            this.chart = {
                data: [ {
                    data: result.map((item) => {
                        return item.percentage;
                    }),
                    label: '%',
                } ],
                labels: result.map((item) => {
                    return item.title;
                }),
                options: {
                    scales: {
                        xAxes: [ {
                            ticks: {
                                beginAtZero: true
                            }
                        } ]
                    }
                },
                colors: [ {
                    backgroundColor: 'rgba(16, 207, 189, 0.5)',
                    borderColor: 'rgba(16, 207, 189, 1)',
                    borderWidth: 1,
                } ],
            };
        }, () => {
            this.toastService.error();
        });
    }

    public chartClicked(e: any): void {
        if (e.active[ 0 ]) {
            const title = e.active[ 0 ]._chart.config.data.labels[ e.active[ 0 ]._index ];
            this.router.navigateByUrl(this.routeService.route('observations.index') + '?search=title:' + title);
        }
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/dashboards/widgets/most-returning-observation-categories/most-returning-observation-categories.component.ts